import TenantConfig from '../../../config';

export const shouldDisplayCreditUnfreeze = (appDataRef) => {
  if (
    TenantConfig?.form.showCreditReportModal &&
    !localStorage.getItem(appDataRef?.current?.id + '_credit_unfreeze_shown')
  ) {
    return true;
  } else {
    return false;
  }
};
